import React from 'react';
import styled from 'styled-components';
import { CheckCircleOutline } from '@mui/icons-material';
import logoSrc from '../White_Logo.png';

// --- Styled Components ---

const SidebarContainer = styled.div`
  width: 45%;
  background-color: #0a2540;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 0 40px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const GlassRectangle = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 450px;
  height: 90%;
  background:rgba(5, 45, 60, 0.1); /* Slightly more transparent white background for glass effect */
  border-left: 1px solid rgba(255, 255, 255, 0.1); /* Subtle border */
  border-right: 1px solid rgba(255, 255, 255, 0.1); /* Subtle border */
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.25); /* Stronger shadow for more depth */
  backdrop-filter: blur(600px); /* Significantly increased blur */
  border-radius: 15px;
  z-index: 0;
  background-attachment: fixed; /* Fix the background for parallax effect */
`;






const CircleWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
`;

const Circle = styled.div<{
  size: number;
  leftOffset: number;
  bottomOffset?: number; // Made optional
  topOffset?: number;    // Added optional topOffset
  opacity: number;
}>`
  position: absolute;
  bottom: ${({ bottomOffset }) => bottomOffset !== undefined ? `${bottomOffset}px` : 'auto'}; // Use bottomOffset if provided
  top: ${({ topOffset }) => topOffset !== undefined ? `${topOffset}px` : 'auto'};       // Use topOffset if provided
  left: ${(props) => `${props.leftOffset}px`};
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  border: 60px solid rgba(226, 246, 252, ${(props) => props.opacity});
  border-radius: 50%;
`;


const SidebarTextOverlay = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
`;


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _HeadlineSecondary = styled.span`
  font-size: 42px;
  font-weight: 100;
  color: white;
  

  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 850px) {
    font-size: 30px;
  }
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _HeadlineT = styled.span`
  font-size: 42px;
  font-weight: 100;
  color: white;
  margin-left: -110px;

  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 850px) {
    font-size: 30px;
  }
`;

const Subtext = styled.span`
  font-family: "General Sans", sans-serif;
  font-size: 20px;

  margin-top: -4px;
  margin-bottom: 1px;
  color: #d1d5db;
  line-height: 1.5;
  width: 100%;
  text-align: left;
  display: block; /* Make span behave like a block for full width */
  margin-left: 0;  /* 🔧 Remove negative margin */
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _Subtext1 = styled.span`
  font-family: "General Sans", sans-serif;
  font-size: 13px;
  font-weight: bold;
  margin-top: 3px;
  color: #d1d5db;
  line-height: 1.5;
  margin-left: -160px;
`;
const FeatureList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 32px 0 0 0;
  margin-left: -70px;
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 13px;
`;

const AuthSidebar: React.FC = () => {
  return (
    <SidebarContainer>
      <GlassRectangle>
        <SidebarTextOverlay>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
</div>



            
  
<FeatureList style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
  <div
    style={{
      
      
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: '20px',
      borderRadius: '5px',
      width: '100%',
    }}
  >
    <img
      src={logoSrc}
      alt="EngazeIQ Logo"
      style={{
        height: '77px',
        marginLeft  : '2px',
      }}
    />
  </div>

  <Subtext style={{ paddingLeft: '20px', color: '#fff',marginLeft: '100px',marginTop:'-30px' }}>
    Unified AI Agents Platform
  </Subtext>

  <FeatureItem style={{ display: 'flex', alignItems: 'center',marginTop:'20px' }}>
    <CheckCircleOutline sx={{ color: '#ff9900', fontSize: '20px', marginLeft: '20px' }} />
    <span style={{ marginLeft: '9px' }}>
      Conversational Interface - Talk to workflows in real time
    </span>
  </FeatureItem>

  <FeatureItem style={{ display: 'flex', alignItems: 'center' }}>
    <CheckCircleOutline sx={{ color: '#ff9900', fontSize: '20px', marginLeft: '20px' }} />
    <span style={{ marginLeft: '9px' }}>
      Multi-Agent Collaboration - AI agents to manage complexity
    </span>
  </FeatureItem>

  <FeatureItem style={{ display: 'flex', alignItems: 'center' }}>
    <CheckCircleOutline sx={{ color: '#ff9900', fontSize: '20px', marginLeft: '20px' }} />
    <span style={{ marginLeft: '9px' }}>
      Voice and text interaction capabilities
    </span>
  </FeatureItem>

  <FeatureItem style={{ display: 'flex', alignItems: 'center' }}>
    <CheckCircleOutline sx={{ color: '#ff9900', fontSize: '20px', marginLeft: '20px' }} />
    <span style={{ marginLeft: '9px' }}>
      Domain-Aware Intelligence - Built for your business
    </span>
  </FeatureItem>
</FeatureList>


          </div>
        </SidebarTextOverlay>
      </GlassRectangle>

      <CircleWrapper>
        {/* <Circle size={1} offset={-250} opacity={0.3} style={{ filter: 'blur(4px)' }}/> */}
        {/* <Circle size={700} offset={-150} opacity={0.3} style={{ filter: 'blur(4px)' }} /> */}
        {/* <Circle size={600} offset={-100} opacity={0.2} style={{ filter: 'blur(4px)' }} /> */}

        <Circle
  size={550}         // First circle size
  leftOffset={-300}  // Horizontal position
  topOffset={160}  // Positioned from top
  opacity={0.2}
  style={{
    filter: 'blur(6px)'
  }}
/>
<Circle
  size={700}         
  leftOffset={-375}  
  topOffset={90}
  opacity={0.2}
  style={{
    filter: 'blur(6px)'
  }}
/>
<Circle
  size={820}         
  leftOffset={-420} 
  topOffset={18}
  opacity={0.2}
  style={{
    filter: 'blur(6px)'
  }}
/>






        {/* <Circle size={350} offset={-100} opacity={0.3} style={{ filter: 'blur(4px)' }}/> */}
      </CircleWrapper>
    </SidebarContainer>
  );
};

export default AuthSidebar;
